export const getLinkList = /* GraphQL */ `
  query ListLinks(
    $tenant: String!
    $landscape: ModelStringKeyConditionInput!
    $limit: Int
    $nextToken: String
  ) {
    listLinks: linkByTenantLandscape(
      tenant: $tenant
      landscape: $landscape
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        menuDescriptions {
          items {
            language
            description
          }
          nextToken
        }
        url
        sort
      }
      nextToken
    }
  }
`;
